
$(document).ready(function(){
  $(".custom-thumbnail-click").click(function(){
     var myEm = $(this).attr('data-thumbnail-id');
    //alert(myEm);
    
     $("#product-thumbnai-rearrange .product__slide-new").each(function(){
         var right_pro = $(this).attr('featured-imd-id');
        if(myEm == right_pro){
        	//alert('ok');
         $('.product__slide-new').not(this).removeClass('active-rerr');
          $('.product__slide-new').not(this).addClass('hide-product');
    $(this).removeClass('hide-product');
           $(this).addClass('active-rerr');
          // $(window).scrollTop(0);
         
        }
       });
  });
});



$(document).ready(function(){
      $('.custom-slide').slick({
        dots: true,
       // infinite: true,
//         centerMode: true,
//         centerPadding: '20px',
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: false,
        
//         prevArrow: $('.feat_prev_1'),
//         nextArrow: $('.feat_next_1'),
        responsive: [
          
            {
            breakpoint: 9999,
            settings: "unslick"
        },
          {
            breakpoint: 1024,
            settings: {
              slidesToShow: 1,
              slidesToScroll: 1,
               dots: true,
            }
          },
          {
            breakpoint: 600,
            settings: {
              slidesToShow: 1,
              slidesToScroll: 1,
               dots: true,
            }
          },
          {
            breakpoint: 480,
            settings: {
              slidesToShow: 1,
              slidesToScroll: 1
            }
          }
          // You can unslick at a given breakpoint now by adding:
          // settings: "unslick"
          // instead of a settings object
        ]
      });
   });
